import bacancyTechnology from "./assets/img/icons/common/bacancy_og.png";
import excelra from "./assets/img/icons/common/Excelra.png";
import resume from "./assets/pdf/resume.pdf";

export const greetings = {
  name: "Abhishek Bhavsar",
  title: "Hi all, I'm Abhishek",
  description:
    "Full Stack Developer with 6+ years of experience in building scalable web applications using Python, Django, React.js, Next.js, Node.js, and AWS. Passionate about clean code, DevOps practices, and delivering impact-driven solutions.",
  resumeLink: resume,
};

export const openSource = {
  githubUserName: "abhishek-code11",
};

export const contact = {
  title: "Get In Touch",
  description: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision. Feel free to reach out!",
  email: "abhibhavsar.dev@gmail.com",
  phone: "+91 7227885771",
  location: "Bangalore, Karnataka, India"
};

export const socialLinks = {
  // instagram: "https://www.instagram.com/i.am_abhii/",
  // twitter: "https://twitter.com/abhishe25713158",
  github: "https://github.com/abhishek-code11",
  linkedin: "https://www.linkedin.com/in/abhibhavsar/",
};

export const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER WITH CLOUD EXPERTISE",
  skills: [
    "Build scalable web applications with React, Node.js and Django",
    "Design and manage cloud infrastructure",
    "Implement DevOps practices with AWS CLI, CI/CD, and Docker",
    "Develop responsive UIs with React, Next, and Tailwind CSS",
  ],

  softwareSkills: [
    {
      skillName: "reactjs",
      fontAwesomeClassname: "vscode-icons:file-type-reactjs",
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "vscode-icons:file-type-next",
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "logos:python",
    },
    {
      skillName: "Django",
      fontAwesomeClassname: "vscode-icons:file-type-django",
    },
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "logos:fastapi",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "logos:nodejs-icon",
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "logos:aws",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "logos:docker-icon",
    },

    {
      skillName: "mongoDB",
      fontAwesomeClassname: "vscode-icons:file-type-mongo",
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "logos:postgresql",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "logos:firebase",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "logos:git-icon",
    },
  ],
};

// based on my above skill set please fill up Skillbars
export const SkillBars = [
  {
    Stack: "Backend Development", //Insert stack or technology you have experience in
    progressPercentage: "90", //Insert relative proficiency in percentage
    description: "Python, Django, FastAPI, Node.js, Express",
  },
  {
    Stack: "Frontend Development", //Insert stack or technology you have experience in
    progressPercentage: "90",
    description: "React.js, Next.js, Vue.js, Tailwind CSS",
  },
  {
    Stack: "Cloud Development", //Insert stack or technology you have experience in
    progressPercentage: "80", //Insert relative proficiency in percentage
    description: "AWS, Docker, Kubernetes",
  },
  {
    Stack: "Database Development", //Insert stack or technology you have experience in
    progressPercentage: "80", //Insert relative proficiency in percentage
    description: "PostgreSQL, MongoDB, MySQL, DynamoDB, Redis",
  },
];

export const educationInfo = [
  {
    schoolName: "K. S. School Of Business Management",
    subHeader: "Master of Science (Information Technology)",
    duration: "August 2015 - April 2020",
    // desc: "Participated in  and published 5 papers.",
    // descBullets: [],
  },
];

export const experience = [
  {
    role: "Senior Software Specialist",
    company: "Excelra",
    companylogo: excelra,
    date: "Feb 2023 - Present",
    desc: "Working as a Senior Software Specialist with focus on cloud development and responsive UIs and Backend development.",
    descBullets: [
      "Built cloud-based applications using Django and AWS (Lambda, S3, EC2), and developed responsive UIs with React and Tailwind CSS",
      "Developed bioinformatics workflow UI using React and integrated Python-based backend services to handle terabytes of sequencing data",
      "Built reusable frontend components in React and integrated user-specific API authentication",
      "Designed and consumed REST APIs in Node.js for dynamic data flow and enhanced plan tracking features"
    ],
  },
  {
    role: "Software Engineer",
    company: "Bacancy Technology",
    companylogo: bacancyTechnology,
    date: "Jan 2020 - Feb 2023",
    desc: "Worked as a Software Engineer developing full-stack applications with React, Node.js, and AWS.",
    descBullets: [
      "Developed modular frontend using React and Redux with secure user-level API authentication and reusable UI modules",
      "Engineered backend using Node.js and managed AWS stack via SAM templates with enhanced monitoring via AWS CloudWatch",
      "Created puppeteer scripts to scrape market data into MongoDB and implemented Passport.js authentication",
      "Built image upload features with AWS S3 and developed RESTful APIs integrating third-party sports-engine API"
    ],
  }
];

export const certifications = [
  {
    name: "AWS Certified Developer - Associate",
    body: "Amazon Web Services",
    date: "2026",
    desc: "Developed, deployed, and debugged cloud-based applications using AWS services and best practices",
    link: "https://www.credly.com/badges/808ebfef-c7df-46d6-a6fc-f8f89aaf4a29"
  },
  {
    name: "AWS Certified Cloud Practitioner",
    body: "Amazon Web Services",
    date: "2024",
    desc: "Validated knowledge of AWS Cloud concepts, services, security, architecture, pricing, and support",
    link: "https://www.credly.com/badges/5870da2c-8539-4c2f-9e6d-c98d70a33a6a"
  }
];

export const projects = [
  {
    name: "GoStar Platform",
    role: "Full-stack developer · Excelra",
    desc: `Flagship small-molecule SAR database for drug discovery. Built Django REST APIs and React compound-search and SAR screens, tuned PostgreSQL queries for high-volume search, and added GoStar AI: natural-language compound search powered by the OpenAI API.`,
    stack: ["React", "Django", "PostgreSQL", "OpenAI API"],
    result: "Serves 10.6M+ structures and 35M+ bioactivity data points",
    tag: "Enterprise · Login required"
  },
  {
    name: "Cloud Solution Platform",
    role: "Full-stack developer · Excelra",
    desc: `Enterprise SaaS product. Designed a modular React component library on top of Django services on AWS, and implemented the authentication and role-based authorization layer.`,
    stack: ["React", "Tailwind CSS", "Django", "AWS Lambda", "S3", "EC2"],
    result: "Role-based access control across the whole platform",
    link: null
  },
  {
    name: "Op2 Platform",
    role: "Full-stack developer · Excelra",
    desc: `Genomics pipeline platform. Built React data-visualization modules on top of Python NGS pipelines, Django services for data processing and pipeline orchestration, and serverless microservices on AWS.`,
    stack: ["React", "Python", "Django", "AWS Lambda"],
    result: "Researchers process terabytes of genomic data",
    tag: "Enterprise · Login required"
  },
  {
    name: "BOP Plan Management (IDMS)",
    role: "Full-stack developer · Excelra",
    desc: `Industrial plant management tool. Wrote FastAPI services for plant workflows and operational data, and React screens that consume them for plan tracking.`,
    stack: ["React", "FastAPI", "Python", "REST APIs"],
    result: "Real-time operational status updates for plant teams",
    link: null
  },
  {
    name: "MyHealth Shop",
    role: "Full-stack developer · Bacancy Technology",
    desc: `Healthcare e-commerce platform for pharmacy and wellness products: catalog, cart, checkout and orders. Built the complete React + Redux storefront and its reusable components, backed by FastAPI services with user-level API authentication, and led sprint planning for the team.`,
    stack: ["React", "Redux", "FastAPI", "REST APIs"],
    result: "Reusable UI modules cut development effort by 30%",
    link: "https://farmeci.com/"
  },
  {
    name: "Tashi Pro",
    role: "Full-stack developer · Bacancy Technology",
    desc: `Weight-loss tracking app. Built Python APIs as Lambda functions on DynamoDB, defined the AWS stack in SAM templates, monitored it with CloudWatch, and built the React front end, all covered by Jest tests.`,
    stack: ["React", "Python", "AWS Lambda", "DynamoDB", "AWS SAM", "CloudWatch", "Jest"],
    result: "Fully serverless backend, deployed and monitored as code",
    link: null
  },
  {
    name: "PackLeader",
    role: "Full-stack developer · Bacancy Technology",
    desc: `Veterinary practice management platform for clinics treating every species: appointments, medical records, cost estimates, billing and payments. Built FastAPI REST APIs and the React appointment and billing screens.`,
    stack: ["React", "FastAPI", "Python", "Payment gateway"],
    result: "Ran backend deployments across multiple environments",
    link: "https://www.packleaderdvm.com/"
  },
  {
    name: "TonkaHockey",
    role: "Full-stack developer · Bacancy Technology",
    desc: `Sports administration site for a hockey association: players, coaches, games and sponsors. Set up the NestJS backend, designed the database schema, integrated the SportsEngine API, and built the React front end, with images stored on Azure.`,
    stack: ["React", "Node.js", "NestJS", "SportsEngine API", "Azure"],
    result: "Live league data pulled from SportsEngine",
    link: "https://www.tonkahockey.org/"
  },
  {
    name: "GoForClose",
    role: "Full-stack developer · Bacancy Technology",
    desc: `Marketing platform for real-estate investors. Set up the Node.js project and the React + Redux front end, designed the database schema, and led integrations across the marketing-ops, Puppeteer and Next-data services.`,
    stack: ["React", "Redux", "Node.js", "Puppeteer", "MongoDB"],
    result: "Market data scraped automatically into MongoDB",
    link: "https://goforclose.com/"
  },
];
